let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fPKCl")).then(() => parcelRequire('vKtw6'));